/** Keep invitation failures actionable without exposing capability tokens. */
export function inviteError(error: unknown): string {
  const e = error as { code?: string; status?: number } | null;
  if (e?.code === 'room-private') return 'This room is private. Ask its owner for an invitation.';
  if (e?.code === 'owner-required' || e?.code === 'not-owner' || e?.code === 'room-owner-required') return 'Only the person who started this room can invite people.';
  if (e?.status === 401) return 'Your session has ended. Sign in again, then retry this invitation.';
  if (e?.status === 404 || e?.status === 410 || /expired|invalid|not-found|no-room|ended/.test(e?.code ?? '')) return 'This invitation has expired, has already been used, or the room has ended. Ask the owner for a new invitation.';
  if (e?.code === 'not-friends') return 'You can send an in-app invitation only to an accepted friend.';
  if (e?.status === 403) return 'This invitation is not available to this account. Ask the room owner for a new one.';
  if (e?.status === 429) return 'Too many invitations just now. Wait a moment and try again.';
  return 'Could not complete the invitation. Check your connection and try again.';
}

export function roomInviteHref(origin: string, token: string): string {
  return `${origin}/#roomInvite=${encodeURIComponent(token)}`;
}
